import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const facultyFilter = JSON.parse(window.facultyFilter);
class FacultiesDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.box   = React.createRef();
    this.state ={dropdownToggle:false}
  }
  setFacultyItems = (selectedId, event) => {
    let faculties = this.props.queryFilter.faculties;
    faculties = faculties ? faculties.split(',') : [];
    if (event.target.checked) {
      faculties = faculties.length ? [...faculties, selectedId] : [selectedId];
    } else {
      faculties = faculties.filter((faculty) => {
        return (faculty != selectedId);
      });
    }
    faculties = faculties.length ? faculties.join() : false;
    this.props.setGlobalState({ faculties });
  }
  SetDropdownToggleVall = ()=>{
    this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
        if (this.state.dropdownToggle == true) {
          this.setState({ dropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
  render() {
    const facultyItems = this.props.queryFilter['faculties'] ? this.props.queryFilter['faculties'].split(',') : [];
    return (
      <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
        <span className="filter-subtxt">Faculties</span>
          <div className="report-list-menu" >
          <div className="branch-list-sec">Select Faculties</div>
              <div className="list_menu_section" >
                <ul className="list_menu">
                  {facultyFilter.map((course) => {
                    let hasChecked = facultyItems.includes(course.id);
                  return (
                    <li key={`faculty_${course.id}`}>
                    <label>
                    <span>
                          <input id={`faculty_${course.id}`} onClick={(e) => this.setFacultyItems(`${course.id}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                      <span className="checkedmark"></span>
                    </span>
                        <span className="dropdownlist_singleline">{course.us_name}</span></label></li>)
                  })}
                </ul>
             </div>
           </div>
       </div>
    );
  }
}
export default withRouter(WithSystem(FacultiesDropDown));
